import { render, staticRenderFns } from "./EstimationTable.vue?vue&type=template&id=05ea51b8&"
import script from "./EstimationTable.vue?vue&type=script&lang=js&"
export * from "./EstimationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports